// extracted by mini-css-extract-plugin
module.exports = {"root":"AvatarInput_root___xQu_"};